/** @format */

export interface DeepLinkOptions {
  camp: string;
  canonicalUrl: string;
  feature: string;
  url: string;
}

export interface BranchIoResponse {
  url: string;
}
